import AccountImpersonatorNotification from './components/ImpersonatorNotification';
import RoutesComponent from './Routes';
import { NAME as namespace } from './constants';
import { accountReducer as reducer } from './reducer';
import { loadAccount } from './actions';
export var actions = {
  loadAccount: loadAccount
};
export var ImpersonatorNotification = AccountImpersonatorNotification;
export var Routes = RoutesComponent;
export var account = {
  namespace: namespace,
  reducer: reducer
};